import { Button } from "@features/atoms/Button"
import { IconArrowRight } from "@features/atoms/Icon"
import { PageIntro } from "@features/content/PageIntro"
import { useBackground } from "@hooks/useAppState"
import { useAppData } from "eddev/hooks"
import { useRouter } from "eddev/routing"
import { defineView } from "eddev/views"
import { AnimatePresence, motion } from "motion/react"
import { useWindowSize } from "react-use"

export default defineView("front-page", (props) => {
  const pillars = useAppData((data) => data.pillars?.nodes ?? [])
  const router = useRouter()

  // Set to idle on load, but if the scene name changes, we want to be notified so we can update the content
  const [{ scene }] = useBackground({
    scene: "idle",
    darken: 0,
  })

  // Get the content for the active pillar scene
  const pillar = pillars.find((p) => p.slug === scene)

  return (
    <div>
      <div className="fixed inset-0 flex items-center justify-center overflow-hidden">
        <motion.div
          initial={{ opacity: 0, filter: "blur(20px)" }}
          animate={{ opacity: 1, filter: "none" }}
          exit={{ opacity: 0, filter: "blur(20px)", scale: 1.2, transition: { delay: 0 } }}
          transition={{ delay: 0.5 }}
        >
          <AnimatePresence mode="popLayout" presenceAffectsLayout initial={false}>
            <motion.div
              key={scene}
              initial={{ opacity: 0, filter: "blur(20px)", scale: 1.2 }}
              animate={{ opacity: 1, filter: "none", scale: 1 }}
              exit={{ opacity: 0, filter: "blur(20px)", scale: 1.2 }}
              transition={{ duration: 0.6 }}
            >
              {pillar ? (
                <PageIntro
                  layoutKey={scene}
                  eyebrow={pillar.title}
                  title={pillar.subtitle}
                  description={
                    <Button
                      className="md:hidden bg-black"
                      variant="outline"
                      icon={<IconArrowRight className="w-[1em] h-[1em]" />}
                      onClick={() => {
                        if (pillar.uri) {
                          router.navigate(pillar.uri)
                        }
                      }}
                    >
                      Learn More
                    </Button>
                  }
                />
              ) : (
                <PageIntro eyebrow="Flying Pigs" title="Digital Marketing Firm" />
              )}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  )
})
